var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page-container"},[_c('searchable-grid',{attrs:{"title":"Early Bird Enrollments","column-defs":_vm.columnDefs,"get-rows-promise":_vm.getRows},on:{"cellDoubleClicked":_vm.onCellDoubleClicked}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }